/**
 * Configuration for Success Screen
 * Edit these values to update coupons, links, and WhatsApp group
 */

export const SUCCESS_CONFIG = {
  coupons: [
    {
      id: 'stannis',
      brand: 'Stannis',
      code: 'PESQUISA2',
      discount: '20% OFF',
      description: 'Na sua primeira compra',
      link: 'https://loja.stannis.com/',
      color: 'from-purple-500 to-indigo-600',
      image: 'images/banner-stannis.png', // Optional: replaces the colored header with an image
      bannerText: 'Conheça as cervejas artesanais premiadas da Stannis, como a vibrante Gold Amélia e a ousada Dear Paula IPA, cheias de sabor e tradição. Aproveite o cupom para ganhar 2 cervejas em compras acima de R$ 99,00.' // Optional: text displayed above the banner
    },
    {
      id: 'bebaluci',
      brand: 'Beba Luci',
      code: 'RETRATO15',
      discount: '15% OFF',
      description: 'Em cervejas sem álcool',
      link: 'https://bebaluci.com.br',
      color: 'from-blue-500 to-cyan-600',
      image: 'images/banner-luci.png', // Optional: replaces the colored header with an image
      bannerText: 'Descubra todo o sabor que uma cerveja sem álcool pode oferecer, e crie novas ocasiões para consumir uma cerveja cheia de sabor. Aproveite o cupom com 15% de desconto + frete grátis para conhecer o sabor da lucidez.' // Optional: text displayed above the banner
    }
  ],
};
